import { KyInstance } from 'ky';

import { handleRequest } from '@/utils/httpUtils';

import {
  FalabellaCreateOrder,
  FalabellaDeletePlugin,
  FalabellaGetLabel,
  FalabellaGetPluginDetails,
  FalabellaGetUserPlugins,
  FalabellaInstall,
  FalabellaOrder,
  FalabellaOrders,
  FalabellaOrdersResponse,
  FalabellaUpdatePlugin,
} from './types';

export interface IReqFalabella {
  orders: FalabellaOrders;
  order: FalabellaOrder;
  createOrder: FalabellaCreateOrder;
  install: FalabellaInstall;
  getUserPlugins: FalabellaGetUserPlugins;
  getPluginDetails: FalabellaGetPluginDetails;
  updatePlugin: FalabellaUpdatePlugin;
  deletePlugin: FalabellaDeletePlugin;
  getLabel: FalabellaGetLabel;
}

export function reqFalabella(http: KyInstance): IReqFalabella {
  const route = 'api/v3/falabella';

  return {
    orders: ({ page, pageSize, clientId, dateFrom, dateTo, orderId, search, status, modality }) =>
      handleRequest<FalabellaOrdersResponse>(http, 'get', `${route}/orders`, {
        searchParams: {
          ...(page !== undefined && { page }),
          ...(pageSize !== undefined && { pageSize }),
          ...(status && { status }),
          ...(modality && { modality }),
          ...(dateFrom && { dateFrom }),
          ...(dateTo && { dateTo }),
          ...(search && { search }),
          ...(orderId && { orderId }),
        },
        headers: {
          'X-Client-ID': clientId,
        },
      }),

    order: ({ clientId, orderId }) =>
      handleRequest(http, 'get', `${route}/orders/${orderId}`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),

    createOrder: ({ clientId, orderId }) =>
      handleRequest(http, 'post', `${route}/orders/${orderId}/create`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),

    install: ({ clientId, sellerId, userId, apiKey }) =>
      handleRequest(http, 'post', `${route}/install`, {
        headers: {
          'X-Client-ID': clientId,
        },
        json: {
          sellerId,
          userId,
          apiKey,
        },
      }),

    getUserPlugins: ({ clientId }) =>
      handleRequest(http, 'get', `api/v3/user/plugins`, {
        headers: {
          'X-Client-ID': clientId,
        },
        searchParams: {
          platform: 'falabella',
        },
      }),

    getPluginDetails: ({ clientId, pluginId }) =>
      handleRequest(http, 'get', `api/v3/user/plugins/${pluginId}/details`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),

    updatePlugin: ({ clientId, pluginId, data }) =>
      handleRequest(http, 'patch', `api/v3/user/plugins/${pluginId}/update`, {
        headers: {
          'X-Client-ID': clientId,
        },
        json: data,
      }),

    deletePlugin: ({ clientId, pluginId }) =>
      handleRequest(http, 'delete', `api/v3/user/plugins/${pluginId}/delete`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),

    getLabel: ({ clientId, orderId }) =>
      handleRequest(http, 'get', `${route}/orders/${orderId}/label`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),
  };
}
